import dayjs, { Dayjs } from 'dayjs';

export const isPastMonthOvertime = (startDate: Dayjs | null | undefined, isOvertimeWork: boolean | null | undefined) =>
  isOvertimeWork === true &&
  dayjs.isDayjs(startDate) &&
  startDate.isValid() &&
  startDate.isBefore(dayjs().startOf('month'), 'day');

export const isPreviousMonthOvertime = (
  startDate: Dayjs | null | undefined,
  isOvertimeWork: boolean | null | undefined
) =>
  isOvertimeWork === true &&
  dayjs.isDayjs(startDate) &&
  startDate.isValid() &&
  startDate.isSame(dayjs().subtract(1, 'month'), 'month');

export const isLastDayOfMonth = (date: Dayjs = dayjs()) => date.isSame(date.endOf('month'), 'day');
